import React, {Component} from 'react';
import Search from '../../search/Search';
import FilterButton from './FilterButton/FilterButton';
import * as settings from "../settings";

export default class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeFilterButton: "all",
            filteredLocations: this.props.locations,
            filterQuery: ""
        };

        this.handleActiveFilterButtonChange = this.handleActiveFilterButtonChange.bind(this);
        this.handleSuggestionClick = this.handleSuggestionClick.bind(this);
        this.handleFilterQueryChange = this.handleFilterQueryChange.bind(this);
        this.filterByQuery = this.filterByQuery.bind(this);
        this.filterByType = this.filterByType.bind(this);
        this.IsMarkerPointOfType = this.IsMarkerPointOfType.bind(this);
    }

    handleActiveFilterButtonChange(event) {
        if (event.target.checked) {
            this.setState({
                activeFilterButton: event.target.value
            });
        }
    }

    handleFilterQueryChange(query) {
        this.setState({
            filterQuery: query
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.activeFilterButton !== this.state.activeFilterButton ||
            prevState.filterQuery !== this.state.filterQuery) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                let suggestionList = null;
                let filteredLocations = this.filterByType(this.props.locations, this.state.activeFilterButton);

                if(this.state.filterQuery && this.state.filterQuery.length > 2) {
                    filteredLocations = this.filterByQuery(filteredLocations, this.state.filterQuery);
                    suggestionList = filteredLocations;
                }

                this.setState({
                    filteredLocations: suggestionList
                }, this.props.setMarkerVisibility(filteredLocations));
            }, settings.delay);
        }
    }

    filterByType(locations, filterType) {
        if (filterType === 'all') {
            return locations;
        } else {
            return locations.filter(x => this.IsMarkerPointOfType(x, filterType));
        }
    }

    IsMarkerPointOfType(point, markerTypeToFiler) {
        return (
            settings.markerStyleTypeMap[point.typeVariable] ===
            markerTypeToFiler
        );
    }

    filterByQuery(locations, query) {
        if (query.length) {
            query = query.toLowerCase();

            let filteredLocations = locations.filter(location => {
                if (location[settings.requestNamesMap.name].toLowerCase().includes(query) ||
                    location[settings.requestNamesMap.country].toLowerCase().includes(query)) {
                    return location;
                }
            });

            return filteredLocations;
        } else {
            return locations;
        }
    }

    handleSuggestionClick(target) {
        if(target.dataset.pointid) {
            this.props.focusMarker(target.dataset.pointid);
        } else {
            this.props.focusMarker(target.childNodes[0].dataset.pointid);
        }
    }

    render() {
        return (
            <aside className="map-component__filters">
                <div className="map-component__column">
                    <h4 className="map-component__column-header">
                        <span>
                            Search by countries or cities
                        </span>
                    </h4>
                    <Search
                        placeholder="Enter country, or city"
                        buttonType="search"
                        searchType="map"
                        locations={this.state.filteredLocations}
                        handleSuggestionClick={this.handleSuggestionClick}
                        handleFilterQueryChange={this.handleFilterQueryChange}/>
                </div>
                <div className="map-component__column">
                    <form className="simple">
                        <fieldset role="radiogroup">
                            <h4 className="map-component__column-header">
                                <legend>
                                    Show on map
                                </legend>
                            </h4>
                            <FilterButton value="all"
                                          isDefaultChecked={true}
                                          handleActiveButtonChange={this.handleActiveFilterButtonChange}/>
                            <FilterButton value="office"
                                          isDefaultChecked={false}
                                          handleActiveButtonChange={this.handleActiveFilterButtonChange}/>
                            <FilterButton value="port"
                                          isDefaultChecked={false}
                                          handleActiveButtonChange={this.handleActiveFilterButtonChange}/>
                        </fieldset>
                    </form>
                </div>
            </aside>
        )
    }
}